<form [formGroup]="form" class="chat-search-container">
  <mat-form-field class="white-bg-input">
    <input matInput formControlName="search" autocomplete="off" [placeholder]="'MAIN.SEARCH' | translate" />
  </mat-form-field>
  <button *ngIf="isSearchValue" mat-button class="mat-icon-button" (click)="handleClearSearch()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</form>
